import { UrlParamKeys } from '../../app/UrlParamKeys';
import {
  RedirectSourceEvent,
  TelemetryEvents,
  VizPortalNavigationEvent
} from '../../common/telemetryEvents/TelemetryEvents';
import { Module } from '../Module';
import { Telemetry } from '../../commonInfra/services/Telemetry';

export interface StateTransition {
  newStateName: string;
  oldStateName: string;
}

export class UrlTelemetryService {

  public static $inject = [
    '$location',
  ];

  public constructor(
    private $location: ng.ILocationService,
  ) { }

  public sendUrlEventsOnStateChange(stateTransition: StateTransition): void {
    let redirectSourceUrlParam = this.$location.search()[UrlParamKeys.RedirectSource];
    if (redirectSourceUrlParam) {
      this.sendRedirectSourceEventAndRemoveUrlParam(redirectSourceUrlParam);
    }

    this.sendNavigationEvent(stateTransition);
  }

  /**
   * Sends a telemetry event if the RedirectSource URL param exists.
   * This assumes that the SSO login carries the query params over through login.
   */
  private sendRedirectSourceEventAndRemoveUrlParam(source: string) {
    // Assuming that source has already been cleaned by the redirect handler
    Telemetry.sendEvent<RedirectSourceEvent>({
      type: TelemetryEvents.RedirectSource,
      source: source,
    });

    this.$location.search(UrlParamKeys.RedirectSource, null);
  }

  private sendNavigationEvent(stateTransition: StateTransition) {
    if (stateTransition.newStateName !== stateTransition.oldStateName) {
      Telemetry.sendEvent<VizPortalNavigationEvent>({
        type: TelemetryEvents.VizPortalNavigation,
        newState: stateTransition.newStateName,
        oldState: stateTransition.oldStateName,
        mixedContentEnabled: true // TODO: We should figure out some way to remove mixedContentEnabled from the telemetry
      });
    }
  }
}

Module.instance().service('UrlTelemetryService', UrlTelemetryService);
